import React from 'react';
import { useTheme } from 'emotion-theming';
import { styled } from '@nykaa/ui-components';
import { getPathStyles } from 'components/Header/helper';

interface PinkBoxProps {
  isLight: boolean;
  color?: string;
}

const Icon = styled.svg<{ isLight: boolean; color?: string }>`
  ${({ isLight, color, theme }) => getPathStyles(isLight, color, theme)};
`;

function PinkBox({ isLight, color }: PinkBoxProps) {
  const theme: Theme = useTheme();
  return (
    <Icon
      isLight={isLight}
      color={color}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        fillRule="evenodd"
      >
        <path
          fill="#FFF"
          fillOpacity="0"
          d="M0 0h24v24H0z"
        ></path>
        <path
          fill={theme.brandPrimary}
          fillRule="nonzero"
          d="M6.783 2.837c1.286-1.015 3.155-.871 4.21.306.548.509.959 1.228 1.271 2.114.45-.892.983-1.591 1.633-2.041l.137-.096a3.192 3.192 0 014.196.626c1.088 1.302.967 3.227-.25 4.36-.128.127-.27.248-.424.361h2.362c.95.043 1.727.807 1.772 1.815l-.003 1.703c-.08.993-.927 1.747-1.887 1.71h-.074v6.039a1.723 1.723 0 01-1.49 1.634l-.147.013H6.539a1.72 1.72 0 01-1.649-1.796v-5.89c-.985.025-1.82-.733-1.89-1.785v-1.66c.017-.494.231-.96.595-1.295a1.816 1.816 0 011.295-.489h2.755c-.546-.316-.961-.674-1.252-1.069a3.134 3.134 0 01.233-4.427zm11.064 10.868H6.78v5.786h11.067v-5.786zm-12.958-3.35l-.002 1.451 14.912-.001.001-1.449-14.911-.001zM16.78 4.957A1.303 1.303 0 0015 4.75l-.146.11c-.392.327-.78.927-1.123 1.721-.111.258-.214.527-.308.802l-.13.403.26-.02c1.523-.132 2.497-.475 3.026-.938l.089-.083a1.302 1.302 0 00.112-1.788zm-7.229-.585a1.243 1.243 0 00-1.661.003c-.511.46-.552 1.247-.036 1.826l.081.102c.438.504 1.317.957 2.758 1.28l.219.046-.056-.32a11.227 11.227 0 00-.125-.575l-.11-.417c-.243-.834-.56-1.46-.973-1.85z"
        ></path>
      </g>
    </Icon>
  );
}

export default PinkBox;
